import React, { FC } from 'react';
import cn from 'classnames';
import { getRenderedCurrencySymbol } from '../../utils/currencyFormatter';

type Props = {
  currencyCode: string;
  className: string;
};

const CurrencySymbol: FC<Props> = ({ currencyCode, className = '' }) => {
  const { glyph, className: internalClassName } = getRenderedCurrencySymbol(currencyCode);

  return (
    <span className={cn(internalClassName, className)}>
      <span className="currency-symbol__glyph">{glyph}</span>
    </span>
  );
};

export default CurrencySymbol;
